import type { Season, WeatherType } from './SeasonTypes';

const seasonalWeather: Record<Season, readonly WeatherType[]> = {
  spring: ['clear', 'cloudy', 'rain', 'fog'],
  summer: ['clear', 'clear', 'cloudy', 'storm'],
  autumn: ['cloudy', 'rain', 'fog', 'wind'],
  winter: ['cloudy', 'snow', 'frost', 'fog'],
};

export class WeatherSystem {
  getWeather(season: Season, seasonDay: number): WeatherType {
    const pool = seasonalWeather[season];
    return pool[seasonDay % pool.length];
  }
}
